<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Listă registre</h2>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă registre</h3>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                    (click)="rerenderChildDT(registru_slug)">
                                    <i class="fa-solid fa-arrows-rotate"></i>
                                </button>
                                <button *ngIf="selectedTabelBorderouSlug !== 'toate' && isAllowedToShowAddDialog()"
                                    type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                    (click)="openAddDialog()">
                                    <i class="fa-solid fa-plus"></i>
                                    Adaugă
                                </button>
                                <button *ngIf="selectedTabelBorderouSlug !== 'toate' && isAllowedToShowAddDialog()"
                                    type="button" class="btn btn-sm btn-warning pull-right ms-1"
                                    (click)="exportRegisterCSV()">
                                    Exportă registru(CSV)
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-filters m-2">
                        <div class="col d-flex justify-content-center">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onTableChange($event)" [value]="defaultParameter.slug">
                                <mat-button-toggle *ngFor="let option of registre$ | async" [value]="option.slug">
                                    {{ option.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Număr Acord/Autorizație</mat-label>
                                        <input matInput type="number" formControlName="acord" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Număr cerere</mat-label>
                                        <input matInput type="number" formControlName="numarCerere" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Agent Economic</mat-label>
                                        <input matInput type="text" formControlName="agentEconomic" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>CUI Firmă</mat-label>
                                        <input matInput type="number" formControlName="cuiFirma" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>CAEN</mat-label>
                                        <input matInput type="number" formControlName="CAEN" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Valabilitate</mat-label>
                                        <mat-select formControlName="valabilityCheck">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option [value]="1">Lipsă valoare</mat-option>
                                            <mat-option [value]="2">Termen greșit</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col">
                                    <strong class="m-0">Adresă punct de lucru</strong>
                                    <mat-checkbox formControlName="punct_lucru" color="primary"></mat-checkbox>
                                </div>
                            </div>

                            <div *ngIf="this.searchParamsForm.get('punct_lucru')?.value">
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Stradă</mat-label>
                                            <input matInput type="text" formControlName="pl_strada" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Număr</mat-label>
                                            <input matInput type="text" formControlName="pl_numar" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Bloc</mat-label>
                                            <input matInput type="text" formControlName="pl_bloc" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Scară</mat-label>
                                            <input matInput type="text" formControlName="pl_scara" />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Etaj</mat-label>
                                            <input matInput type="text" formControlName="pl_etaj" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field>
                                            <mat-label>Apartament</mat-label>
                                            <input matInput type="text" formControlName="pl_apartament" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning">
                                        Închide
                                    </button>
                                </div>
                                <div class="col d-flex justify-content-end">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="updateCurrentDataTable()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today"
                                                    (selectedChange)="updateCurrentDataTable()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col">
                                            <h3>Selecție rapidă (Registre)</h3>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex flex-wrap gap-2">
                                            <button *ngFor="let year of calendarYears" type="button"
                                                class="action-button m-0" [class.selected]="
                                                selectedFilteringButton === year.toString()
                                                " (click)="setSpecificYear(year)">
                                                <span>{{ year }}</span>
                                            </button>
                                            <button type="button" class="action-button m-0" [class.selected]="
                                                selectedFilteringButton === 'all_years'
                                                " (click)="setAllYears()">
                                                <span>TOATE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div *ngIf="
		              !allowedRegistreSlugs.includes(selectedTabelBorderouSlug) ||
		              selectedTabelBorderouSlug === 'toate'
		            ">
                        <app-toate-tabel-registru [dataTableParams]="dataTableParams"></app-toate-tabel-registru>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'acord-de-functionare'">
                        <app-acord-functionare [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-acord-functionare>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'acord-comercializare'">
                        <app-acord-comercializare [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-acord-comercializare>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'acord-temporar'">
                        <app-acord-temporar [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-acord-temporar>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'autorizatie-alimentatie-publica'">
                        <app-autorizatie-alimentatie-publica [dataTableParams]="dataTableParams"
                            [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-autorizatie-alimentatie-publica>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'autorizatie-piata-targ'">
                        <app-autorizatie-piata [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-autorizatie-piata>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'autorizatie-recreative'">
                        <app-autorizatie-recreative [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-autorizatie-recreative>
                    </div>
                    <div *ngIf="selectedTabelBorderouSlug === 'acord-terase-sezoniere'">
                        <app-acord-terase-sezoniere [dataTableParams]="dataTableParams" [registru_id]="registru_id"
                            (dataTableParametersChange)="onDataTableChange($event)"></app-acord-terase-sezoniere>
                    </div>

                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>